import React from "react"
import "./Hero.css"
import video1 from "../assets/videohome.mp4"
import { useTranslation } from "react-i18next"

const HeroSection = () => {
  const { t } = useTranslation()

  return (
    <div className="hero-container">
      <video className="hero-video" autoPlay loop muted playsInline>
        <source src={video1} type="video/mp4" />
        Your browser does not support this video.
      </video>
      <div className="hero-overlay">
        <h1>{t("home.main_title")}</h1>
        <p>{t("home.description")}</p>
      </div>
    </div>
  )
}

export default HeroSection